@if(showOptions) {
<div>
	<div class="content">
		<div class="label">
			{{ sortByLabel }}
		</div>
		<div class="dropdown">
			<div class="value" (click)="setShowMenu($event)">
				{{ Loc(sortType) }}
			</div>
			@if(showMenu) {
			<div class="options">
				@for(sortType of sortTypes; track sortType) {
				<a (click)="sort(sortType)">{{ Loc(sortType) }}</a
				>}
			</div>
			}
		</div>
		<div class="caret" (click)="setShowMenu($event)"></div>
	</div>
</div>
}
